import chroma from "chroma-js";
import colors from "vuetify/lib/util/colors";

export default Object.entries(colors)
  .filter(([key, val]) => key != "shades")
  .map(([, val]) => chroma.scale( [ val.darken4, val.darken2, val.base, val.lighten2 ] ).correctLightness().colors())
  .flat();